module.exports = __webpack_public_path__ + "static/media/Avatar9b.1a45b9b6.png";